<template>
  <div class="reschedule-mode">
    <div class="reschedule-mode__rooms">
    <el-alert
      v-if="selectedRoomsList.length >= 31"
      title="單筆訂單 31 晚 為上限"
      type="error"
      center
      show-icon
      class="reschedule-mode__limit-alert"
    />
    <div v-for="(type, typeIndex) in roomTypeList" :key="`type-${typeIndex}`">
      <div style="margin-bottom: 32px; border-top: solid 12px #f9fafb" class="roomType">
        <el-row style="display: flex">
          <el-col :span="7" style="background-color: #f2f2f2; padding: 8px 0px">
            <el-row>
              <div
                style="display: flex; align-items: stretch; line-height: 1.8; margin-bottom: 4px; cursor: pointer"
                @click="type.isViewMore = !type.isViewMore"
              >
                <el-col :span="8">
                  <div>
                    <img
                      v-if="type.image"
                      :src="type.image"
                      :alt="`${type.title}照片`"
                      style="width: 91px; height: 70px; object-fit: cover; border-radius: 8px"
                    />
                    <img
                      v-else
                      src="@assets/images/default_room.jpg"
                      alt="預設房型圖片"
                      style="width: 91px; height: 70px; object-fit: cover; border-radius: 8px"
                    />
                  </div>
                  <el-popover placement="right-start" trigger="click" width="160" popper-class="settings-menu-popper">
                    <div style="display: flex; flex-direction: column; gap: 10px; padding: 5px 0">
                      <el-popover placement="right-start" trigger="click" width="450" @click.stop>
                        <el-button slot="reference" round size="small" @click.stop style="width: 100%; margin-left: 0">
                          查看可入住種類
                        </el-button>
                        <div style="max-height: 250px; overflow-y: auto; width: auto">
                          <div
                            style="
                              font-weight: bold;
                              margin-bottom: 8px;
                              border-bottom: 1px solid #eee;
                              padding-bottom: 4px;
                              position: fixed;
                              background-color: #ffffff;
                              width: 420px;
                            "
                          >
                            所有可入住種類 (共 {{ type.categories.length }} 項)
                          </div>
                          <div style="margin-top: 28px">
                            <div
                              v-for="(item, index) in type.categories"
                              :key="index"
                              style="padding: 8px 0; font-size: 14px; border-bottom: 1px dashed #f0f0f0"
                            >
                              {{ item.title }}
                            </div>
                          </div>
                        </div>
                      </el-popover>
                    </div>
                    <el-button slot="reference" type="text" icon="el-icon-setting" @click.stop style="font-size: 28px; padding-right: 40px" />
                  </el-popover>
                </el-col>
                <el-col :span="14" style="text-align: left; margin-left: 4px; color: #6c6b6b">
                  <div style="font-weight: bold; color: #121931; font-size: 16px">
                    {{ type.title }}
                    <span style="font-size: 12px; color: #6c6b6b"> | {{ type.rooms.length }}間 </span>
                  </div>
                  <div>可入住數：1~{{ type.accommodates }}</div>
                  <div>
                    <div v-for="(item, index) in type.categories.slice(0, 3)" :key="`Category-${index}`">
                      {{ item.title }}
                    </div>
                  </div>
                </el-col>
                <el-col :span="1" style="display: flex; align-items: center">
                  <font-awesome-icon
                    :icon="['far', 'chevron-down']"
                    :style="{
                      color: '#ea6a2a',
                      fontSize: '16px',
                      transition: 'transform 0.6s ease',
                      transform: type.isViewMore ? 'rotate(180deg)' : 'rotate(0deg)',
                    }"
                  />
                </el-col>
              </div>
            </el-row>
          </el-col>
          <el-col :span="17" style="padding: 0px; display: flex; flex-direction: column">
            <el-row style="flex: 1; display: flex; flex-wrap: wrap">
              <el-col
                v-for="(defaultPrice, defaultPriceIndex) in type.defaultPrices"
                :key="`defaultPrice-${defaultPriceIndex}`"
                :span="3"
                style="
                  border: solid 1px #0000000f;
                  margin: 0px 6px;
                  background-color: #ffffff;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                NT${{ formatNumber(defaultPrice) }}
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row
          v-show="type.isViewMore"
          v-for="(room, roomIndex) in type.rooms"
          :key="`room-${roomIndex}`"
          class="room"
          :class="type.isViewMore ? 'fade-in' : 'fade-out'"
        >
          <el-col :span="7" style="background-color: #ffffff">
            <div style="display: flex; justify-content: left; align-items: center; padding: 0 8px">
              <div style="font-weight: 400; color: #000000; padding-left: 12px">{{ room.roomTitle }}</div>
            </div>
          </el-col>
          <el-col :span="17" style="padding: 0px">
            <el-row>
              <el-col
                v-for="(dateRoom, dateRoomIndex) in room.availabilityByDate"
                :key="`dateRoom-${dateRoomIndex}`"
                :span="3"
                :class="{
                  'selected-cell': isSelected(room.roomId, dateRoom.date),
                  'disabled-cell': isDisabledCell(type, room.roomId, dateRoom.date, dateRoom, room),
                }"
                :style="getCellStyle(type, room, dateRoom)"
                style="margin: 0px 6px; border: solid 1px #e5e7eb"
              >
                <el-tooltip
                  :content="getCellTooltip(type, dateRoom)"
                  placement="top"
                  :enterable="false"
                  :disabled="!getCellTooltip(type, dateRoom)"
                >
                  <span
                    v-if="getCellLabel(type, room.roomId, dateRoom.date, dateRoom, room)"
                    class="ellipsis-text"
                  >
                    {{ getCellLabel(type, room.roomId, dateRoom.date, dateRoom, room) }}
                  </span>
                  <span
                    v-else
                    class="ellipsis-text"
                    @click="handleDateRoomClick(type, room, dateRoom)"
                  >
                    NT${{ formatNumber(dateRoom.priceStartAt) }}
                  </span>
                </el-tooltip>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapGetters } from 'vuex'

import { StatusMetaMap } from '../enums/statusMap'
import { RoomStatusEnum } from '../enums/roomStatusEnum'
import { formatHotelStayRange } from '@utils/format-hotel-stay'
import {
  bookingMatchesRoomDate,
  checkDateContinuity,
  datesMatch,
  getOrderCategoryIds,
  getOrderCategoryTitles,
  getRoomTypeCategoryTitles,
  isRoomTypeCategoryEligible,
  mapInitialBookingsToSelected,
  mergeBookingsIntoSelection,
  roomIdsMatch,
} from '@utils/hotel-room-selection'

export default {
  name: 'hotelRescheduleMode',
  components: {
    FontAwesomeIcon,
  },
  props: {
    roomTypeList: {
      type: Array,
      required: true,
    },
    containerUuid: {
      type: String,
      default: '',
    },
    initialBookings: {
      type: Array,
      default: () => [],
    },
    orderGuests: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      StatusMetaMap,
      RoomStatusEnum,
      selectedRoomsList: [],
    }
  },
  computed: {
    orderPetCount() {
      return Array.isArray(this.orderGuests) ? this.orderGuests.length : 0
    },
    orderCategoryIds() {
      return getOrderCategoryIds(this.orderGuests)
    },
    orderCategoryTitles() {
      return getOrderCategoryTitles(this.orderGuests)
    },
    selectedStayRange() {
      return formatHotelStayRange({
        bookings: this.selectedRoomsList,
        showCheckoutDate: this.showCheckoutDate,
      })
    },
    ...mapGetters('hotel/setting', ['showCheckoutDate']),
  },
  watch: {
    roomTypeList: {
      immediate: true,
      handler(list) {
        if (!list || !list.length) return
        this.applyInitialSelectionFromGrid()
      },
    },
    selectedRoomsList: {
      deep: true,
      handler() {
        this.emitSelectionChange()
      },
    },
  },
  mounted() {
    this.emitSelectionChange()
  },
  methods: {
    emitSelectionChange() {
      this.$emit('selection-change', {
        active: true,
        selectedRoomsList: [...this.selectedRoomsList],
        selectedStayRange: this.selectedStayRange,
        orderPetCount: this.orderPetCount,
      })
    },
    applyInitialSelectionFromGrid() {
      if (!this.roomTypeList?.length || !this.initialBookings?.length) return

      if (this.selectedRoomsList.length) {
        this.selectedRoomsList = mergeBookingsIntoSelection(
          this.selectedRoomsList,
          this.roomTypeList,
          this.initialBookings
        )
      } else {
        this.selectedRoomsList = mapInitialBookingsToSelected(this.roomTypeList, this.initialBookings)
      }
      this.emitSelectionChange()
    },
    resetSelection() {
      this.selectedRoomsList = []
      this.applyInitialSelectionFromGrid()
    },
    formatNumber(num) {
      return num?.toLocaleString()
    },
    isOwnedByCurrentOrder(room, dateRoom) {
      if (dateRoom.status !== RoomStatusEnum.BOOKING) return false

      if (dateRoom.booking?.containerUuid && this.containerUuid) {
        return dateRoom.booking.containerUuid === this.containerUuid
      }

      const date = dateRoom.date
      return (this.initialBookings || []).some((booking) => bookingMatchesRoomDate(booking, room, date))
    },
    isCategoryIneligible(type) {
      return !isRoomTypeCategoryEligible(type, this.orderCategoryIds)
    },
    isCapacityIneligible(type) {
      return type.accommodates < this.orderPetCount
    },
    isSelected(roomId, date) {
      return this.selectedRoomsList.some((item) => roomIdsMatch(item.roomId, roomId) && datesMatch(item.date, date))
    },
    isDisabledCell(type, roomId, date, dateRoom, room) {
      if (this.isSelected(roomId, date)) return false
      if (this.isCategoryIneligible(type)) return true
      if (this.isCapacityIneligible(type)) return true
      if (this.isOwnedByCurrentOrder(room, dateRoom)) return false
      if ([RoomStatusEnum.CLOSE, RoomStatusEnum.BOOKING, RoomStatusEnum.RESERVE].includes(dateRoom.status)) {
        return true
      }
      const hasOtherRoomThisDate = this.selectedRoomsList.some(
        (item) => datesMatch(item.date, date) && !roomIdsMatch(item.roomId, roomId)
      )
      if (hasOtherRoomThisDate) return true
      return this.selectedRoomsList.length >= 31
    },
    isCellClickable(type, roomId, date, dateRoom, room) {
      return !this.isDisabledCell(type, roomId, date, dateRoom, room)
    },
    getCellLabel(type, roomId, date, dateRoom, room) {
      if (this.isCategoryIneligible(type)) return '種類不符'
      if (this.isCapacityIneligible(type)) return '容納不足'
      if (dateRoom.status === RoomStatusEnum.BOOKING && !this.isOwnedByCurrentOrder(room, dateRoom)) {
        return StatusMetaMap[dateRoom.status].label
      }
      if ([RoomStatusEnum.CLOSE, RoomStatusEnum.RESERVE].includes(dateRoom.status)) {
        return StatusMetaMap[dateRoom.status].label
      }
      if (this.isDisabledCell(type, roomId, date, dateRoom, room)) return null
      return null
    },
    getCellTooltip(type, dateRoom) {
      if (this.isCategoryIneligible(type)) {
        const orderPets = this.orderCategoryTitles.join('、') || '—'
        const roomPets = getRoomTypeCategoryTitles(type).join('、') || '—'
        return `本訂單寵物：${orderPets}；此房型可入住：${roomPets}`
      }
      if (this.isCapacityIneligible(type)) {
        return `本訂單共 ${this.orderPetCount} 隻寵物，此房型最多可入住 ${type.accommodates} 隻`
      }
      return ''
    },
    getCellStyle(type, room, dateRoom) {
      const roomId = room.roomId
      const date = dateRoom.date
      const label = this.getCellLabel(type, roomId, date, dateRoom, room)
      const isClickable = this.isCellClickable(type, roomId, date, dateRoom, room)

      if (this.isSelected(roomId, date)) {
        return {
          backgroundColor: '#fdf0e9',
          color: '#6c6b6b',
          cursor: 'pointer',
        }
      }

      if (this.isCategoryIneligible(type) || this.isCapacityIneligible(type)) {
        return {
          backgroundColor: '#f2f2f2',
          color: '#6c6b6b80',
          cursor: 'not-allowed',
        }
      }

      if (this.isOwnedByCurrentOrder(room, dateRoom)) {
        return {
          backgroundColor: '#ffffff',
          color: '#6c6b6b',
          cursor: 'pointer',
        }
      }

      if (label) {
        return {
          backgroundColor: StatusMetaMap[dateRoom.status]?.color || '#f2f2f2',
          color: StatusMetaMap[dateRoom.status]?.textColor || '#6c6b6b',
          cursor: 'not-allowed',
        }
      }

      return {
        backgroundColor: StatusMetaMap[dateRoom.status]?.color || '#ffffff',
        color: StatusMetaMap[dateRoom.status]?.textColor || '#6c6b6b',
        cursor: isClickable ? 'pointer' : 'not-allowed',
      }
    },
    handleDateRoomClick(type, room, dateRoom) {
      const roomId = room.roomId
      const date = dateRoom.date

      if (!this.isCellClickable(type, roomId, date, dateRoom, room)) return

      const existingIndex = this.selectedRoomsList.findIndex(
        (item) => roomIdsMatch(item.roomId, roomId) && datesMatch(item.date, date)
      )

      if (existingIndex !== -1) {
        this.selectedRoomsList.splice(existingIndex, 1)
      } else {
        const sameDateIndex = this.selectedRoomsList.findIndex((item) => datesMatch(item.date, date))
        if (sameDateIndex !== -1) {
          this.selectedRoomsList.splice(sameDateIndex, 1)
        }
        this.selectedRoomsList.push({ roomId, date, room, type, dateRoom })
      }
    },
    onClickConfirm() {
      if (this.selectedRoomsList.length > 31) {
        this.$message({
          message: `抱歉，單筆訂單上限為 31 晚，目前已選 ${this.selectedRoomsList.length} 晚。`,
          type: 'error',
          center: true,
        })
        return
      }

      if (!checkDateContinuity(this.selectedRoomsList)) {
        this.$message({
          message: '您選擇的日期不連續，請補齊中間的日期或重新選擇',
          type: 'error',
          center: true,
        })
        return
      }

      this.$emit('confirm', [...this.selectedRoomsList])
    },
  },
}
</script>

<style scoped lang="scss">
.reschedule-mode {
  position: relative;
}

.reschedule-mode__limit-alert {
  position: sticky;
  bottom: 0;
  z-index: 3;
  width: 90%;
  margin: 0 auto 8px;
}

.el-button--text {
  font-weight: 400;
  color: #ea6a2a;
}

.el-col {
  text-align: center;

  .roomType .room & {
    line-height: 65px;
  }
}

.fade-in {
  animation: fadeIn 0.8s ease forwards;
}
.fade-out {
  animation: fadeOut 0.4s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-5px);
  }
}

.ellipsis-text {
  display: inline-block;
  max-width: 85px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.selected-cell {
  box-shadow: 0 0 0 1px #ea6a2a inset;
  border-color: #ea6a2a !important;
  background-color: #fdf0e9 !important;
  border-radius: 8px;
}

.disabled-cell {
  opacity: 0.7;
}
</style>
